export const defaultAdImage =
    'https://static.finncdn.no/_c/mfinn/static/images/no-image.5bf83e47.svg';
